import { useTranslation } from 'react-i18next';

import { SVGIconType } from '../../../constants/svgIcon';
import { SvgIcon } from '../../Molecules';
import {
  BasicPopupContainer,
  PopUpButtonColors,
} from '../Containers/BasicPopupContainer';

import styles from './DeleteJourneyPopup.module.css';

type DeleteJourneyPopupProps = {
  onPrimary: () => void;
  onCancel: () => void;
};

export const DeleteJourneyPopup = (props: DeleteJourneyPopupProps) => {
  const { onPrimary, onCancel } = props;
  const { t } = useTranslation();

  return (
    <BasicPopupContainer
      primaryButtonLabel={t('Delete')}
      primaryButtonColor={PopUpButtonColors.DANGER}
      onPrimaryButtonClick={onPrimary}
      onSecondaryButtonClick={onCancel}
    >
      <div className={styles.popupContent}>
        <SvgIcon name={SVGIconType.RubbishBin} width={60} height={60} />
        <div className={styles.greyRibbon}>
          {t('Journey and records deleted are irrecoverable.')}
        </div>
        <div className={styles.warningText}>
          {t('Are you sure to delete the Journey?')}
        </div>
      </div>
    </BasicPopupContainer>
  );
};
